<div class="header">
  <form
    name="headerDetails"
    novalidate
    autocomplete="off"
    #headerDetails="ngForm"
  >
    <div class="row user-info-row" *ngIf="!hideHeader">
      <div class="col-lg-3 col-md-6 col-sm-6 col-12 title-nps">
        <img
          class="mg-rt-15 cardinal-logo"
          role="button"
          alt="Cardinal Logo"
          src="../../../../assets/images/cardinalLogo.svg"
        />
        <h2 class="nps-heading hidden-xs" title="NPHS Web Ordering (v1.0.14)">
          <span class="red">
            <strong> NPHS </strong>
          </span>
          Web Ordering
        </h2>
        <span
          class="logout-xs visible-xs"
          tabindex="0"
          (click)="onLogoutClick('user')"
          role="button"
        >
        </span>
        <div
        *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
          class="col-lg-2 col-md-6 col-sm-12 col-6 pd-tp-25 pd-lr-0 pd-for-sm pd-for-xs visible-sm"
        >
          <div class="control-group">
            <label
              class="control-label mg-tb-label-3"
              data-ng-if="!header.isAAAUserRole"
            >
              Pharmacy:
            </label>

            <div class="controls">
              <span
                class="pharmacy ellipsis"
                [title]="selectedAccount?.pharmacyName"
                data-ng-if="!header.isAAAUserRole"
              >
                {{ selectedAccount?.pharmacyName }}
              </span>
            </div>
          </div>

          <div
            class="control-group top-mg-info"
            data-ng-class="{'no-margin': header.isAAAUserRole}"
          >
            <label class="control-label mg-tb-label-2"> Phone: </label>
            <div class="controls">
              <span
                class="phone ellipsis"
                [title]="selectedAccount?.pharmacyNumber"
              >
                {{ selectedAccount?.pharmacyNumber }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-4 col-md-5 col-sm-5 col-10 pd-tp-25 pd-lr-0 pd-for-xs acc-block d-md-block d-lg-block"

        [ngClass]="{
          ' mobile-col-width': showMobile
        }"
      >
        <div
        *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
          class="control-group account-mobile-style"
          [ngStyle]="{
            'margin-left': showMobile ? '-11em' : ''
          }"
        >
          <label class="control-label line-ht-25 xs-margin-0"> Account: </label>
          <div
            class="account-dropdown"
            [ngStyle]="{
              width: showMobile ? '216px' : '316px'
            }"
          >
            <ng-select
              id="account"
              #account
              [items]="accountList"
              [searchable]="false"
              [searchFn]="searchAccountByShipTo"
              [matTooltip]="selectedAccount?.customerName"
              [matTooltipShowDelay]="1000"
              [ngClass]="{
                'acc-max-height': showMobile
              }"
              [ngStyle]="{
                width: showMobile ? '171px' : '270px'
              }"
              style="position: relative"
              [appendTo]="'body'"
              class="account-div custom"
              [(ngModel)]="selectedAccount"
              (change)="changeAccount($event)"
              [ngModelOptions]="{
                standalone: true
              }"
              [clearable]="false"
              bindLabel="customerName"
            >
              <ng-template ng-header-tmp>
                <input
                  id="accInp1"
                  #accInp1
                  autofocus
                  style="width: 100%; line-height: 24px"
                  type="text"
                  (input)="account.filter($event.target.value)"
                />
              </ng-template>
            </ng-select>
            <span class="time-zone-style">
              [{{ selectedAccount?.timeZoneText }}]
            </span>
          </div>
        </div>
        <div
          class="control-group d-none d-md-block d-lg-block"
          *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
          [ngClass]="{
            'd-block': showUserInfo,
            'd-none': !showUserInfo
          }"
        >
          <div class="row">
            <div class="col-lg-11 col-md-11 col-sm-11 col-12">
              <div class="control-group mg-tp-6 mw-425">
                <span class="account-no-header">
                  <label class="control-label mg-tb-label-2">Account No:</label>
                  <span [title]="selectedAccount?.customerShipToNum">
                    {{ selectedAccount?.customerShipToNum }}</span
                  >
                </span>
                <span class="use-default-chkbx">
                  <mat-checkbox
                    [checked]="selectedAccount?.isDefault"
                    (change)="changeDefaultAccount(selectedAccount.isDefault)"
                    class="check-box"
                  >
                    <strong>Use as default</strong>
                  </mat-checkbox>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-1 col-md-1.5 col-sm-5 col-12 pd-tp-25 pd-lr-0 pd-for-xs acc-block tablet-visible"
          *ngIf="showMobile &&  (userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
        >
          <div
            class="control-group"
            style="margin-left: -12em; margin-top: -10px"
            [ngClass]="{ 'mg-lf-xs-0': showMobile }"
          >
            <label class="control-label line-ht-25 xs-margin-0 flt_left">
              Mobile:
            </label>
            <div class="account-dropdown2">
              <ng-select
                name="mobileValue"
                #mobileValue="ngModel"
                [items]="mobiles"
                [(ngModel)]="selectedMobile"
                bindLabel="mobileName"
                class="forms-control form-control1 mobile-dropdown account-div"
                placeholder="Select Mobile"
              ></ng-select>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-12 col-sm-6 col-12 pd-tp-25 pd-for-sm pd-for-xs user-wrapper-tablet info-hide-for-small"
          [ngClass]="{
            'text-end mg-tp-tablet pd-tp-0': showMobile,
            'text-start mg-tp-tablet': !showMobile
          }"
        >
          <div
            class="logout-wrapper"
            [ngStyle]="{ 'padding-top': showMobile ? '0' : '8px' }"
          >
            <div class="row">
              <div

              class="col-lg-12 col-md-12 col-sm-12 col-8">
                <label class="control-label mg-tb-label-3">User:</label>
                <div class="dropdown" role="button">
                  <span class="ellipsis pd-l-5 username"
                    >{{ loggedInUser?.firstName }}
                    {{ loggedInUser?.lastName }}</span
                  >

                  <span class="caret" *ngIf="!restrictInternalUser && (userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"></span>

                  <div class="dropdown-content" *ngIf="!restrictInternalUser && (userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)">
                    <p
                      class="dropdown-option"
                      tabindex="0"
                      (click)="changeSecurityQuestion()"
                      role="button"
                    >
                      <span
                        class="glyphicon glyphicon-lock cur-pntr"
                        inert></span>
                      Security Question
                    </p>
                  </div>
                </div>
              </div>
              <div class="top-mg-info help-top-wrapper">
                <span
                *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
                class="suggestion-block">
                  <a
                    href="../../../../assets/images/NuclearWebOrderingHelpFile.pdf"
                    target="_blank"
                    tabindex="0"
                    class="help-icon"
                    title="Click to view NPHS Web Ordering Support Guide"
                  >
                    Help
                    <fa-icon
                      class="glyphicon glyphicon-question-sign cur-pntr"
                      [icon]="faQuestionCircle"
                    ></fa-icon>
                  </a>

                  <img
                    class="mg-rt-10 hidden-xs suggestion_icon"
                    role="button"
                    alt="Send Suggestions"
                    src="../../../../assets/images/wow-mail-icon.svg"
                    title="Send Suggestions"
                    tabindex="0"
                    placement="bottom"
                    (click)="showPopover()"
                  />
                </span>

                <button
                  type="button"
                  name="button"
                  class="button primary logout hidden-xs"
                  [ngClass]="{ 'logout-position': !showMobile }"
                  (click)="onLogoutClick('user')"
                >
                  LOG OUT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-1 col-md-1.5 col-sm-2 col-xs-5 pd-tp-25 pd-lr-0 pd-for-xs acc-block desktop-visible"
        *ngIf="showMobile && (userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
      >
        <div class="control-group" style="margin-left: -12em">
          <label class="control-label line-ht-25 xs-margin-0 flt_left">
            Mobile:
          </label>
          <div class="account-dropdown2">
            <ng-select
              name="mobileValue"
              #mobileValue="ngModel"
              [items]="mobiles"
              [(ngModel)]="selectedMobile"
              bindLabel="mobileName"
              class="forms-control form-control1 mobile-dropdown account-div"
              placeholder="Select Mobile"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div
        class="col-lg-2 col-md-3 col-sm-6 col-12 pd-tp-25 pd-lr-0 pd-for-sm pd-for-xs d-lg-block"
        *ngIf="userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned "
        [ngClass]="{ 'd-block': showUserInfo, 'd-none': !showUserInfo }"
      >
        <div class="control-group" data-ng-if="!header.isInvoiceView">
          <label
            class="control-label mg-tb-label-3"
            data-ng-if="!header.isAAAUserRole"
          >
            Pharmacy:
          </label>

          <div class="controls AAA-dropdown">
            <span
              class="pharmacy ellipsis"
              [title]="selectedAccount?.pharmacyName"
              data-ng-if="!header.isAAAUserRole"
            >
              {{ selectedAccount?.pharmacyName }}
            </span>
          </div>
        </div>
        <div
          class="control-group top-mg-info"
          data-ng-if="!header.isInvoiceView"
        >
          <label class="control-label mg-tb-label-2">Phone:</label>
          <div class="controls">
            <span
              class="phone ellipsis"
              [title]="selectedAccount?.pharmacyNumber"
            >
              {{ selectedAccount?.pharmacyNumber }}
            </span>
          </div>
        </div>
      </div>
      <div

        class="col-lg-3 col-md-6 col-sm-6 col-12 pd-tp-25 pd-for-sm pd-for-xs user-wrapper-desktop info-hide-for-small"
      >
        <div class="logout-wrapper">
          <div class="row">
            <div
            class="col-lg-12 col-md-12 col-sm-12 col-8">
              <label class="control-label mg-tb-label-3">User:</label>
              <div class="dropdown" role="button">
                <span class="ellipsis pd-l-5">
                  {{ loggedInUser?.firstName }}
                  {{ loggedInUser?.lastName }}
                </span>

                <span class="caret" *ngIf="!restrictInternalUser && (userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"></span>

                <div class="dropdown-content" *ngIf="!restrictInternalUser && (userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)">
                  <p
                    class="dropdown-option"
                    tabindex="0"
                    (click)="changeSecurityQuestion()"
                    role="button"
                  >
                    <span
                      class="glyphicon glyphicon-lock cur-pntr"
                      inert
                    ></span>
                    Security Question
                  </p>
                </div>
              </div>
            </div>
            <div class="top-mg-info help-top-wrapper">
              <span
              *ngIf="(userRoleDetails.roleAssigned != noRoleAssignStatus.NoRoleAssigned)"

              class="suggestion-block">
                <a
                  href="../../../../assets/images/NuclearWebOrderingHelpFile.pdf"
                  target="_blank"
                  tabindex="0"
                  class="help-icon"
                  title="Click to view NPHS Web Ordering Support Guide"
                >
                  Help
                  <fa-icon
                    class="glyphicon glyphicon-question-sign cur-pntr"
                    [icon]="faQuestionCircle"
                  ></fa-icon>
                </a>

                <img
                  class="mg-rt-10 hidden-xs suggestion_icon"
                  role="button"
                  alt="Send Suggestions"
                  src="../../../../assets/images/wow-mail-icon.svg"
                  title="Send Suggestions"
                  tabindex="0"
                  placement="bottom"
                  (click)="showPopover()"
                />
                <div
                  class="popover bottom fade in"
                  ng-class="{ in: isOpen }"
                  style="top: 85px; left: -60px"
                  *ngIf="showSuggestionPopOver"
                >
                  <div class="arrow"></div>

                  <div class="popover-inner">
                    <h3 class="popover-title">Send Suggestions</h3>

                    <div class="popover-content">
                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div>
                            <textarea
                              [(ngModel)]="suggestionBox"
                              class="form-control mg-tp-10 hg-auto"
                              placeholder="Enter NPS Web Ordering website improvement suggestion here. These may not be responded to for 24 hours."
                              rows="5"
                              maxlength="2000"
                              (change)="onSuggestionBox($event)"
                            ></textarea>
                            <div
                              class="col-lg-2 col-md-2 col-sm-2 col-xs-4"
                            ></div>
                            <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                              <button
                                type="button"
                                tabindex="0"
                                class="button secondary mg-tp-19"
                                (click)="onCancelSuggestionClick()"
                              >
                                CANCEL
                              </button>
                            </div>

                            <div
                              class="col-lg-4 col-md-4 col-sm-5 col-xs-5 col-lg-offset-1"
                            >
                              <button
                                type="button"
                                tabindex="0"
                                class="button primary mg-tp-19"
                                (click)="onSendSuggestionClick()"
                                [ngClass]="{ disabled: !(suggesionBox != '') }"
                              >
                                SEND
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <button
                type="button"
                name="button"
                class="button primary logout hidden-xs"
                tabindex="0"
                (click)="onLogoutClick('user')"
              >
                LOG OUT
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
      *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
      class="animation-user-block">
        <span class="glyphicon-wrapper">
          <span role="button" tabindex="0">
            <em
              class="down-toggle-header"
              title="Show Header"
              data-ng-if="header.hideDetailsUser"
              (click)="onShowUserInfoClick()"
            ></em>
          </span>
        </span>
      </div>
    </div>

    <!-- WO SUB HEADER -->

    <div
      class="row redline-row"
      *ngIf="!hideHeader"
      [ngClass]="{'hide-border' : userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned}"
    >
      <div class="col-lg-12 col-md-12 col-sm-12 col-12"></div>
    </div>
    <div
    *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned)"
    class="row bottom-header " [ngClass]="{'mobile-calender-row' : rejectedCount > 0,'calender-row' : rejectedCount == 0}">
      <div class="row" style="padding-top: 3px; padding-bottom: 2px">
        <div
          class="col-md-7 col-lg-8 col-sm-6 col-12 tleft pd-lr-0 pd-tp-2 d-block d-sm-block d-sm-none d-md-block"
        >
          <div style="display: flex">
            <div style="display: flex">
              <span
                type="button"
                class="d-none d-sm-none d-md-none d-lg-block material-icons arrow-circle"
                (click)="collapseHeader()"
                *ngIf="!hideHeader"
                style="margin-left: 2px; cursor: pointer; color: slategrey"
                matTooltip="Hide Header"
                [matTooltipShowDelay]="700"
              >
                arrow_circle_up
              </span>
              <span
                type="button"
                class="material-icons arrow-circle"
                *ngIf="hideHeader"
                (click)="collapseHeader()"
                style="margin-left: 2px; cursor: pointer; color: slategrey"
                matTooltip="Show Header"
                [matTooltipShowDelay]="700"
              >
                arrow_circle_down
              </span>
              <strong class="headerClock" [ngClass]="{'tab-header-clock' :rejectedCount > 0}" *ngIf="showHeaderClockFlag">
                {{ currentTime }} {{ selectedAccount?.timeZoneText }}
              </strong>
            </div>

            <div
              *ngIf="hideHeader"
              style="
                width: max-content;
                display: inline-flex;
                margin-left: 10px;
              "
              id="hide-account-dropdown"
              [ngClass]="{ 'account_placement': rejectedCount > 0 }"
            >
              <div class="header-text-pad">
                <label> Account:</label>
              </div>
              <ng-select
                id="hideHeadAccount"
                #hideHeadAccount
                [items]="accountList"
                [searchable]="false"
                [searchFn]="searchAccountByShipTo"
                [matTooltip]="selectedAccount?.customerName"
                [matTooltipShowDelay]="1000"
                [ngClass]="{
                  'acc-max-height2': showMobile
                }"
                [ngStyle]="{
                  width: showMobile ? '171px' : '270px'
                }"
                style="position: relative"
                [appendTo]="'body'"
                class="account-div custom"
                [(ngModel)]="selectedAccount"
                (change)="changeAccount($event)"
                [ngModelOptions]="{
                  standalone: true
                }"
                [clearable]="false"
                dropdownPosition="bottom"
                bindLabel="customerName"
              >
                <ng-template ng-header-tmp>
                  <input
                    id="accInp1"
                    #accInp1
                    autofocus
                    style="width: 100%; line-height: 24px"
                    type="text"
                    (input)="hideHeadAccount.filter($event.target.value)"
                  />
                </ng-template>
              </ng-select>
              <span class="time-zone-style">
                [{{ selectedAccount?.timeZoneText }}]
              </span>
            </div>

             
            <div class="rejected_dropdown_div">
              <div
                class="col-12 col-md-1 col-lg-1 d-block d-sm-block d-sm-block d-md-block reject-req-msg"
                *ngIf="rejectedCount > 0" [ngClass]="{'tab-reject-req-msg' : rejectedCount > 0}"
              >
                <div style="display: inline-flex">
                  <fa-icon
                  class="red cur-pntr"
                  [icon]="faExclamationCircle"
                >
                </fa-icon>
                  <div [ngClass]="{'tab-refresh-span' : rejectedCount > 0}">
                    <span [ngClass]="{'tab-refresh-btn' : rejectedCount > 0}" class="refreshBtn">
                      You have {{ rejectedCount }}
                      rejected request notifications.
                    </span>
                  </div>
                  <div>
                    <button
                    *ngIf="!showNewRejectNotification"
                      mat-stroked-button
                      class="condensed-btn"
                      (click)="openRequest()"
                    >
                      View Details
                    </button>
                    <button
                    *ngIf="showNewRejectNotification"
                      mat-stroked-button
                      class="condensed-btn"
                      (click)="openRejectNotificationDialog()"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="col-md-1 col-lg-1 col-3 today-button-container">
          <button
            *ngIf="showToday"
            (click)="showTodayData()"
            mat-stroked-button
            class="today-btn conde nsed-btn mat-stroked"
          >
            Today
          </button>
        </div>

        <div class="col-md-4 col-lg-3 col-sm-6 col-9 text-end date-header" [ngClass]="{'tab-data-header' : rejectedCount > 0}">
          <img
            style="cursor: pointer"
            src="assets/images/caret_left.svg"
            alt="Change Date"
            (click)="changeDate(-1)"
          />
          <span style="margin-left: 5px; margin-right: 5px">
            <input
              class="header-date-picker"
              [ngClass]="{'tab-header-date-picker' : rejectedCount > 0}"
              disabled="true"
              readonly
              [(ngModel)]="dayBoardDate"
              [ngModelOptions]="{ standalone: true }"

            />
          </span>
          <img
            style="cursor: pointer"
            src="assets/images/caret_right.svg"
            alt="Change Date"
            (click)="changeDate(1)"
          />
          <input
            style="visibility: hidden; width: 0px"
            [matDatepicker]="picker"
            [(ngModel)]="dayBoardDate"
            [ngModelOptions]="{ standalone: true }"
            (dateChange)="dateChange(dayBoardDate)"
          />
          <mat-datepicker-toggle
            style="display: none"
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <img
            style="cursor: pointer; width: 20px"
            src="assets/images/calendar_icon.svg"
            alt=""
            (click)="picker.open()"
          />
        </div>
      </div>
    </div>
  </form>
</div>
